// extracted by mini-css-extract-plugin
export default {"userAttendanceForm":"UserAttendanceForm_userAttendanceForm__eC0Sf","name":"UserAttendanceForm_name__XJttM","select":"UserAttendanceForm_select__nqirj"};